module.exports = __webpack_public_path__ + "static/img/3.8fb81f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.png
// module id = ZK0V
// module chunks = 0